module.exports = __webpack_public_path__ + "media/images/free-brand-1a6329caeca62a922da5e4f068d7e2b8.png";